// Where a ticket note's text names its own ticket, so that — and only that — can be a link.
//
// The note's structured `ticket: { id, number }` is the whole authority: the ticket-note-writer
// job stamps it only on the note it writes when a ticket is opened, and a note someone types
// never has one. So a typed "#45" is never a link, and inside a ticket note only the token that
// matches `ticket.number` is: `#4` does not match inside `#42`, a `#42` glued to a word
// (`abc#42`) or to another hash is not a reference, and only the first match counts.
//
// Returns `{ start, end }` offsets into `text`, or `null` when the text never names the ticket
// (the caller then keeps its separate "View ticket #N" link).
export function findTicketReference(text, ticketNumber) {
  if (typeof text !== 'string') return null
  if (!Number.isSafeInteger(ticketNumber) || ticketNumber < 0) return null

  const match = new RegExp(`(^|[^\\w#])(#${ticketNumber})(?!\\d)`).exec(text)
  if (!match) return null

  const start = match.index + match[1].length
  return { start, end: start + match[2].length }
}

// Stands in for the reference while mention markup is interpolated around it, so the link is
// placed into the note's own text and never into markup built from it. NUL cannot occur in a
// note's text or in the mention markup.
export const TICKET_REFERENCE_SENTINEL = '\u0000ticket-reference\u0000'
